@if (mode() === "ADD" || mode() === "RENAME") {
	<div class="text">
		<ng-content></ng-content>
		@if (!entry.secondLineTranslate) {
			<span class="h6">{{ entry.secondLine }}</span>
		}
		@if (entry.secondLineTranslate) {
			<span class="h6" translate="{{ entry.secondLineTranslate }}"></span>
		}
	</div>
}
@if (!(mode() === "ADD" || mode() === "RENAME")) {
	<div class="text">
		@if (entry.labelTranslate) {
			<span class="h3" [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></span>
		}
		@if (!entry.labelTranslate) {
			<span class="h3" [ngClass]="entry.labelClasses">{{ entry.label }}</span>
		}
		@if (!entry.secondLineTranslate) {
			<span class="h6">{{ entry.secondLine }}</span>
		}
		@if (entry.secondLineTranslate) {
			<span class="h6" translate="{{ entry.secondLineTranslate }}"></span>
		}
		@if (originalHasChangeMarker) {
			<div class="info change-marker">
				<div>
					@if (entry.original.changeMarker.changed) {
						<span class="badge changed-badge" translate="process.compare.changed"></span>
					}
					@if (entry.original.changeMarker.added) {
						<span class="badge added-badge" translate="process.compare.added"></span>
					}
					@if (entry.original.changeMarker.deleted) {
						<span class="badge deleted-badge" translate="process.compare.deleted"></span>
					}
				</div>
				<div>
					@if (entry.original.changeMarker.subelements > 0) {
						<i class="ico ico-exclamation-mark subelements"></i>
					}
				</div>
			</div>
		}
	</div>
	<ng-container />
}
